import {
   Actions, 
   CollectionDescriptor, 
   GeoDocument, 
   Root, 
   Storage,
   Users as FUsers
} from 'firestar'
import { ReadOptions } from 'firestar/lib/CollectionDescriptor';
import {
   AddressType
} from './Address'
import Plugins from './Plugins';

interface CasinoInfoType{
   id: string,
   name: string
}

interface CasinoUserType extends FUsers.UserInfo, Readonly<Root>{
   role: FUsers.Role
}

export interface LatLng {
   latitude: number,
   longitude: number
}

export interface AccessKey extends Root {
   
}

export const LocationCheckOptions = {
   radius : 'Radius',
   bounds : 'Bounds'
}

type LocationCheckType = keyof typeof LocationCheckOptions

interface CasinoType extends Root, GeoDocument, CasinoInfoType {
   address?: AddressType
   coverImage?: string | null,
   thumbnail?: string | null,
   collectionId?: string,
   radius?: number,
   bounds?: LatLng[],
   locationCheck?: LocationCheckType,
   askCardNumber?: boolean,
   pointFactor?: number,
   plugins?: { [key: string]: Plugins.Plugin }
}

namespace Casinos {

   export type Casino = CasinoType
   export type CasinoInfo = CasinoInfoType
   export type CasinoUser = CasinoUserType

   export function getCasinos(descriptor?:CollectionDescriptor) {
      return Actions.readCollection<CasinoType>('casinos',descriptor)
   }

   export function getCasinoInfo(casino:Casino) {
      return {
         name: casino.name,
         id: casino.id
      }
   }

   export function getCasinoWithId(id: string, readOptions?: ReadOptions) {
      return Actions.readDocument<Casino>(`casinos/${id}`, readOptions)
   }

   export function addCasino(document: Partial<Casino> | Casino) {
      return Actions.addToCollection<Casino>('casinos', document as Casino)
   }

   export function updateCasino(id: string, document: Partial<Casino>) {
      return Actions.updateGeoDocument(id, document, 'casinos')
   }

   export function addUser(casinoId: string, userId: string, document: Partial<Casino> | Casino) {
      return Actions.writeDocument<Casino>(`casinos/${casinoId}/users/${userId}`, document)
   }

   export function deleteUser(casinoId: string, userId: string) {
      return Actions.deleteDocument(`casinos/${casinoId}/users/${userId}`)
   }

   export function getUsers(casinoId: string, descriptor?:CollectionDescriptor) {
      return Actions.readCollection<CasinoUserType>(`casinos/${casinoId}/users`, descriptor)
   }

   export function uploadThumbnail(casinoId: string, data: any) {
      return Storage.uploadFileDataToPath(
         `casinos/${casinoId}/thumbnail.png`,
         data,
         'data_url',
         {
            contentType: 'image/ong'
         }
      )
   }

   export function uploadCoverImage(casinoId: string, data: any) {
      return Storage.uploadFileDataToPath(
         `casinos/${casinoId}/cover-image.png`,
         data,
         'data_url',
         {
            contentType: 'image/ong'
         }
      )
   }

   export function createAccessKey(casinoId: string, document: Partial<AccessKey> | AccessKey) {
      return Actions.addToCollection<AccessKey>(`casinos/${casinoId}/accessKeys`,document)
   }

   export function deleteAccessKey(casinoId: string, accessKey: string) {
      return Actions.deleteDocument(`casinos/${casinoId}/accessKeys/${accessKey}`)
   }

   export function getAccessKeys(casinoId: string) {
      return Actions.readCollection(`casinos/${casinoId}/accessKeys`)
   }

   export function validateAccessKey(casinoId: string, accessKey: string) {
      return new Promise((resolve, reject) => {
         try {
            if (accessKey.trim().length == 0) {
               throw new Error('No Access Key Found')
            }
            const response = Actions.readDocument(`casinos/${casinoId}/accessKeys/${accessKey}`)
            if (response == null) {
               throw new Error('Invalid Access Key')
            }
            resolve(response)
         } catch (error) {
            reject(error)
         }
      })
   }
}

export default Casinos

